import React from 'react';

/**
 * Label + control + hint + error wrapper with the aria wiring the inputs rely on.
 * Inputs in this folder render themselves inside a Field; use it directly only
 * for custom controls.
 */
export const inputClass = (hasError, extra = '') => [
  'block w-full rounded-md border bg-white px-3 py-3 sm:py-2 text-base sm:text-sm text-gray-900 placeholder-gray-400 shadow-sm',
  'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500',
  'disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed',
  hasError ? 'border-red-500' : 'border-gray-300',
  extra
].join(' ');

export const labelClass = 'block text-sm font-medium text-gray-700 mb-1.5';

export const describedBy = (id, { hint, error }) => {
  const ids = [];
  if (hint) ids.push(`${id}-hint`);
  if (error) ids.push(`${id}-error`);
  return ids.length ? ids.join(' ') : undefined;
};

const Field = ({ id, label, hint, error, required, optionalLabel = false, className = '', children, labelAs = 'label' }) => {
  const LabelTag = labelAs;
  const labelProps = labelAs === 'label' ? { htmlFor: id } : { id: `${id}-label` };

  return (
    <div className={className}>
      {label && (
        <LabelTag {...labelProps} className={labelClass}>
          {label}
          {required && <span className="ml-0.5 text-red-600" aria-hidden="true">*</span>}
          {!required && optionalLabel && <span className="ml-1 text-xs font-normal text-gray-500">(optional)</span>}
        </LabelTag>
      )}
      {children}
      {hint && !error && (
        <p id={`${id}-hint`} className="mt-1 text-xs text-gray-500">{hint}</p>
      )}
      {error && (
        <p id={`${id}-error`} className="mt-1 text-sm text-red-600" role="alert">{error}</p>
      )}
    </div>
  );
};

export default Field;
